export const MODAL = {
  about: 'about',
  changePassword: 'changePassword',
  refreshCache: 'refreshCache',
  exportToZip: 'exportToZip',
  regenerateAggregatedEnv:'regenerateAggregatedEnv',
  regenerateAggregatedRisk:'regenerateAggregatedRisk',
  regenerateAggregatedTables: 'regenerateAggregatedTables',
  none: ''
};
